import React, { useEffect, useState } from "react";
import { Loader2, Zap } from "lucide-react";
import { api } from "../lib/api";

export const CustomTopUp = ({ onBuy, busy }) => {
  const [cfg, setCfg] = useState(null);
  const [credits, setCredits] = useState(100);
  useEffect(() => { api.creditsPricing().then(setCfg).catch(() => {}); }, []);
  if (!cfg) return null;
  const n = Number(credits || 0);
  const ok = Number.isInteger(n) && n >= cfg.min_credits && n <= cfg.max_credits;
  const price = Math.max(1, Math.ceil(n * cfg.unit_price_inr));
  return (
    <div className="mt-5 rounded-3xl border border-slate-200 bg-white p-6 flex flex-col md:flex-row md:items-end gap-4" data-testid="custom-topup">
      <div className="flex-1">
        <p className="text-sm font-medium text-slate-900">Top up any amount</p>
        <p className="text-xs text-slate-500 mt-0.5">Choose exactly how many credits you need ({cfg.min_credits}–{cfg.max_credits.toLocaleString("en-IN")}). ₹{cfg.unit_price_inr} per credit.</p>
        <div className="mt-3 flex items-center h-11 max-w-xs rounded-xl border border-slate-200 bg-slate-50 focus-within:border-sky-400 focus-within:bg-white transition-colors">
          <Zap size={14} className="ml-3 fill-amber-400 text-amber-500" />
          <input type="number" step={1} min={cfg.min_credits} max={cfg.max_credits} value={credits} onChange={(e) => setCredits(e.target.value)} data-testid="custom-topup-credits"
            className="flex-1 min-w-0 h-full bg-transparent px-3 text-sm font-mono text-slate-900 outline-none" />
          <span className="pr-3 text-sm text-slate-400">credits</span>
        </div>
        {!ok && credits !== "" && <p className="mt-1 text-xs text-rose-600" data-testid="custom-topup-error">Enter a whole number between {cfg.min_credits} and {cfg.max_credits.toLocaleString("en-IN")}</p>}
      </div>
      <button onClick={() => onBuy({ credits: n })} disabled={!ok || busy} data-testid="custom-topup-pay"
        className="h-11 px-6 rounded-full bg-slate-900 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-slate-700 disabled:opacity-50 transition-colors">
        {busy && <Loader2 size={15} className="animate-spin" />} Pay ₹{ok ? price.toLocaleString("en-IN") : "—"}
      </button>
    </div>
  );
};

export default CustomTopUp;
